import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';

import {
  AdminApiKeyCreatedAction,
  AdminApiKeyErroredAction,
  AdminApiKeyFormPageRequestedAction,
  AdminApiKeyLoadedAction,
  CreateAdminApiKeyAction,
} from './admin-api-key-form.actions';
import { AdminApiKeyService } from '../api-key/admin-api-key.service';
import { ApiKeyFormCrudEffects } from './api-key-form-crud.effects';

@Injectable()
export class AdminApiKeyFormEffects extends ApiKeyFormCrudEffects {
  getAdminKeyById$ = this.getApiKeyByIdEffect(
    AdminApiKeyFormPageRequestedAction,
    AdminApiKeyLoadedAction,
    AdminApiKeyErroredAction,
  );

  createAdminApiKey$ = this.createApiKeyEffect(
    CreateAdminApiKeyAction,
    AdminApiKeyCreatedAction,
    AdminApiKeyErroredAction,
  );

  redirectAfterCreated$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AdminApiKeyCreatedAction),
        tap(({ apiKey }) =>
          this.router.navigate(['/admin/api-keys', apiKey.id], {
            state: { generatedApiKey: apiKey.apiKey },
          }),
        ),
      ),
    {
      dispatch: false,
    },
  );

  constructor(
    protected actions$: Actions,
    protected apiKeyService: AdminApiKeyService,
    private router: Router,
  ) {
    super(actions$, apiKeyService);
  }
}
